import { useMutation, UseMutationResult } from 'react-query'

import { Submit, SubmitSuccess } from 'common/interfaces'
import api from 'utils/api'
import { useIsOnline } from 'utils/hook'
import { useCurrentClaimId } from 'views/AdjustersHub/utils/hooks'
import { OfflineRequestsService } from 'views/AdjustersHub/utils/offlineRequestsService'

function normalizeSubmit(payload: Submit): Submit {
  const fix = (v: any): any => {
    if (typeof v === 'string') {
      return v.replace(/\\(?![\\/]|u[0-9a-fA-F]{4})/g, '\\\\')
    }

    if (Array.isArray(v)) return v.map(fix)
    if (v && typeof v === 'object') {
      const out: any = {}
      for (const k in v) out[k] = fix(v[k])
      return out
    }

    return v
  }

  return {
    ...payload,
    data: fix(payload.data),
    full_data: fix(payload.full_data),
  }
}

async function sendData(data: Submit): Promise<SubmitSuccess> {
  const normalized = normalizeSubmit(data)
  const response = await api.post<SubmitSuccess>('documents/', normalized)
  return response.data
}

export default function useSubmit(): UseMutationResult<SubmitSuccess, unknown, Submit> {
  const claimID = useCurrentClaimId()
  const isOnline = useIsOnline()

  return useMutation<SubmitSuccess, unknown, Submit>(sendData, {
    mutationKey: 'submitDoc',
    onError: async (error, params) => {
      if (!isOnline) {
        await OfflineRequestsService.saveRequest({
          method: 'useSubmit',
          payload: params,
          claimID,
        })

        return
      }

      console.log('error useSubmit', error)
    },
  })
}
